// extracted by mini-css-extract-plugin
export default {"updateBtn":"ObjectProtectionButton_updateBtn__610er"};